import { render, staticRenderFns } from "./follow_up_add.vue?vue&type=template&id=08d3f380&scoped=true&"
import script from "./follow_up_add.vue?vue&type=script&lang=js&"
export * from "./follow_up_add.vue?vue&type=script&lang=js&"
import style0 from "./follow_up_add.vue?vue&type=style&index=0&id=08d3f380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3f380",
  null
  
)

export default component.exports